export default __webpack_public_path__ + "static/media/fabriLife (2).3fa33937.png";